<template>
  <div class="about">
<!--      <basic-echarts ref="basic"></basic-echarts>-->
      <geo-map style="background: #002556" ref="basicMap"  :height="'800'"></geo-map>
  </div>
</template>
<script>
  import BasicEcharts from "@/components/Echarts/BasicEcharts";
  import GeoMap from "@/components/Map/GeoMap";

  export default {
    name: 'home',
    components:{
      BasicEcharts,
      GeoMap
    },
    data(){
      return {
        mapChart: null
      }
    },
    mounted() {
      this.getMapChart();
      this.getData();
    },
    methods:{
      getMapChart(){
        this.mapChart = this.$refs.basicMap.$refs.mapEcharts.myChart;
      },
      async getData(){
        //let result = await this.$http.get('/api/haha');
        //console.log(result)
        let option = {
          title: {
            text: 'ECharts 入门示例'
          },
          tooltip: {},
          legend: {
            data:['销量']
          },
          xAxis: {
            data: ["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
          },
          yAxis: {},
          series: [{
            name: '销量',
            type: 'bar',
            data: [5, 20, 36, 10, 10, 20]
          }]
        };
        //this.$refs.basic.refresh(option);
        this.$refs.basicMap.initMap();


        this.mapChart.on('click', (param) => {
            //console.log(param);
            if(param.name !== '南海诸岛'){
                this.$refs.basicMap.refreshMap(param.name);
            }
        });

      }
    }
  }
</script>